(function () {
	const READY_CLASS = 'privacy-banner-ready';
	const BANNER_ID = 'shopify-pc__banner';
	const SCROLL_THRESHOLD = 24;
	const FALLBACK_MS = 8000;
	const html = document.documentElement;

	if (html.classList.contains('shopify-design-mode')) {
		html.classList.add(READY_CLASS);
		return;
	}

	let fallbackTimer = 0;
	let bannerObserver = null;

	const getBanner = () => document.getElementById(BANNER_ID);

	const suppressBanner = (banner) => {
		if (!banner || html.classList.contains(READY_CLASS)) return;
		banner.inert = true;
	};

	const reveal = () => {
		if (html.classList.contains(READY_CLASS)) return;

		html.classList.add(READY_CLASS);
		if (bannerObserver) {
			bannerObserver.disconnect();
			bannerObserver = null;
		}
		const banner = getBanner();
		if (banner) banner.inert = false;
		window.clearTimeout(fallbackTimer);
		window.removeEventListener('pointerdown', reveal, true);
		window.removeEventListener('keydown', onKeyDown, true);
		window.removeEventListener('keyup', reveal, true);
		window.removeEventListener('scroll', onScroll, true);
		document.removeEventListener('focusin', onHiddenBannerFocus, true);
	};

	const onKeyDown = (event) => {
		if (event.metaKey || event.ctrlKey || event.altKey) return;
		if (
			event.key === 'Meta' ||
			event.key === 'Control' ||
			event.key === 'Alt' ||
			event.key === 'Shift'
		) {
			return;
		}

		// Let Tab reach skip link / header first. Reveal after this key so the
		// visually hidden banner is not inserted into the tab order mid-stroke.
		if (event.key === 'Tab') {
			window.addEventListener('keyup', reveal, {
				once: true,
				capture: true
			});
			return;
		}

		reveal();
	};

	const onHiddenBannerFocus = (event) => {
		if (html.classList.contains(READY_CLASS)) return;
		const banner = getBanner();
		if (!banner || !banner.contains(event.target)) return;
		suppressBanner(banner);
		event.target.blur();
	};

	const onScroll = () => {
		if (Math.abs(window.scrollY) < SCROLL_THRESHOLD) return;
		reveal();
	};

	const watchBanner = () => {
		suppressBanner(getBanner());

		bannerObserver = new MutationObserver(() => {
			suppressBanner(getBanner());
		});

		bannerObserver.observe(document.documentElement, {
			childList: true,
			subtree: true
		});
	};

	document.addEventListener('focusin', onHiddenBannerFocus, true);

	if (Math.abs(window.scrollY) >= SCROLL_THRESHOLD) {
		reveal();
		return;
	}

	watchBanner();

	window.addEventListener('pointerdown', reveal, {
		capture: true,
		passive: true
	});
	window.addEventListener('keydown', onKeyDown, true);
	window.addEventListener('scroll', onScroll, {
		capture: true,
		passive: true
	});
	fallbackTimer = window.setTimeout(reveal, FALLBACK_MS);
})();
